import React from "react";
import Skeleton from "react-loading-skeleton";

const SideBarLoader = ({ expanded }) => {
  return [1, 2, 3, 4, 5]?.map((i) => (
    <div style={{ display: "flex", gap: 5, alignItems: "center" }}>
      <div style={{ padding: 10 }} key={i}>
        <Skeleton height={33} width={33} enableAnimation={true} />
      </div>
      {expanded && (
        <div style={{ width: "100%", marginRight: 15 }}>
          <Skeleton height={30} />
        </div>
      )}
    </div>
  ));
};

export default SideBarLoader;
